import { Layout } from '../../components/Layout/Layout';
import { Entity } from '../../types/Entity';
import { MentionedEntity } from '../../types/MentionedEntity';
import { Mentions } from '../../types/Mentions';
import { SharedChipProps } from '../../types/SharedChipProps';
import { CommentDraft } from './CommentDraft';
import { CommentData, MentionEntityType } from './types';

interface Props {
  entity: Entity;
  isMentionsLoading: boolean;
  isSubmitting: boolean;
  mentions: Mentions;
  resolvedMentions: Mentions;
  chips?: SharedChipProps[];
  onSubmit: (commentData: CommentData) => void;
  onMentionSearch?: (updatedSearch: string) => void;
  onMention?: (mention: MentionedEntity<MentionEntityType>) => void;
}

export const CommentsFooter = ({
  chips,
  entity,
  isMentionsLoading,
  isSubmitting,
  mentions,
  resolvedMentions,
  onMentionSearch,
  onMention,
  onSubmit,
}: Props) => {
  return (
    <Layout borderTop="border.divider" px={6} py={3}>
      <CommentDraft
        chips={chips}
        entity={entity}
        isFocused={true}
        isMentionsLoading={isMentionsLoading}
        isSubmitting={isSubmitting}
        mentions={mentions}
        resolvedMentions={resolvedMentions}
        onMention={onMention}
        onMentionSearch={onMentionSearch}
        onSubmit={onSubmit}
      />
    </Layout>
  );
};
